import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export interface ProfileData {
  fullName: string;
  phone?: string;
  // Client specific
  nationalId?: string;
  iban?: string;
  jobTitle?: string;
  monthlyIncome?: number;
  monthlyCommitments?: number;
  // Lawyer specific
  licenseNumber?: string;
  commercialRegistryNumber?: string;
  officeLocation?: string;
  licensePhotoUrl?: string;
  registryPhotoUrl?: string;
}

export const getProfile = async (userId: string): Promise<ProfileData | null> => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      return userDoc.data() as ProfileData;
    }
    return null;
  } catch (error) {
    console.error('Error getting profile:', error);
    throw error;
  }
};

export const updateProfile = async (
  userId: string,
  data: Partial<ProfileData>
): Promise<void> => {
  try {
    await updateDoc(doc(db, 'users', userId), {
      ...data,
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.error('Error updating profile:', error);
    throw error;
  }
};
